<script lang="ts" context="module">
    const elementRef = writable<HTMLElement | null>(null)
    export function setOnboardingReference(element: HTMLElement | null) {
        elementRef.set(element)
    }

    //@ts-ignore
    globalThis.setOnboardingReference = setOnboardingReference
</script>

<script lang="ts">
    import { writable } from "svelte/store"
    import Portal from "svelte-portal"
    import { fade, scale, type TransitionConfig } from "svelte/transition"
    import { quintOut } from "svelte/easing"

    let bounds: DOMRect | null

    // recalculate bounds whenever the element reference changes
    $: bounds = $elementRef?.getBoundingClientRect() || null

    function zoom({
        delay = 0,
        duration = 400,
        easing = quintOut,
    } = {}): TransitionConfig {
        if (!bounds) throw new Error("No bounds!")
        const storedBounds = bounds
        return {
            delay,
            duration,
            easing,
            css: (t, u) => `
                filter: blur(${u*5}px);
                transform: scale(${1 + u*2});
                transform-origin: ${storedBounds.x + storedBounds.width / 2}px ${
                    storedBounds.y + storedBounds.height / 2
            }px;`,
        }
    }
</script>

<Portal>
    {#if bounds}
      <div style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; backdrop-filter: blur(10px); z-index: 9999;"></div>
      <svg width={"100%"} height={"100%"} style="position: fixed; top: 0; left: 0; z-index: 10000;">
        <mask id="hole">
          <rect width="100%" height="100%" fill="white" />
          <rect x={bounds.x} y={bounds.y} width={bounds.width} height={bounds.height} rx="10" ry="10" fill="black"
            transition:zoom|global={{duration: 1000}}>
          </rect>
        </mask>
        <rect width="100%" height="100%" fill="black" mask="url(#hole)" />
      </svg>
    {/if}
  </Portal>